import { ColumnsType, DeleteIcon, EditIcon } from '@/components/_common';
import ItemsStockModal from '@/components/_common/ItemsStockModal';
import { useDeleteInvoiceNoteItems } from '@/core/domain/invoice/invoiceNoteItems/invoiceNoteItemsParts/InvoiceNoteItms.hooks';
import { InfiniteTable } from '@/components/_common';
import { InvoiceItemList } from '@/core/domain/invoice/invoiceItem/invoiceItem.types';
import {
  StockItem,
  StockItemType,
} from '@/core/domain/stock/StockItems/StockItems.types';
import { COLUMNS_WIDTH, getTableScrollX } from '@/utils/table';
import { Button, Divider, Modal, Space } from 'antd';
import { useDisclosure } from '@/hooks';
import { useIntl } from 'react-intl';
import { useLocation } from 'react-router-dom';
import SpaceForButton from '@/components/_common/SpaceForButtons';
import {
  InvoiceOriginReferenceEntity,
  InvoiceType,
} from '@/core/domain/invoice/invoices/invoices.enums';
import { FaExchangeAlt } from 'react-icons/fa';
import NoteItemsSelectCfopModal from './NoteItemsSelectCfopModal';
import useConfigurationColumnsPart from '@/hooks/useConfigurationColumnsPart';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import Authorities from '@/types/Authority';
import { useInvoiceFormContext } from '../../../InvoiceFormProvider';
import NoteItemsSelectAliquotModal from './NoteItemsSelectAliquotModal';
import formatterPrice from '@/utils/number/formatterPrice';
import formatterPercent from '@/utils/number/formatterPercent';
import SelectTasksListModal from '@/components/_common/SelectTasksListModal';
import { Task } from '@/core/domain/operational/Tasks/Tasks.types';
import { Key, useState } from 'react';
import InvoicePartModal from '../../../InvoiceItemModal/PartFormsModal';
import InvoiceItemServiceModal from '../../../InvoiceItemModal/ServiceFormsModal';
import UpdateTaxesModal from '../../../InvoiceItemModal/UpdateTaxesModal';
import { useDeleteMultipleInvoiceItems } from '@/core/domain/invoice/invoiceItem/invoiceItem.hook';

export default function InvoiceNoteItemsGeneralTable() {
  const intl = useIntl().formatMessage;
  const title = (columnName: string) =>
    intl({ id: `invoiceNoteItems.column.${columnName}` });

  const {
    invoiceId,
    disabledFields,
    invoiceItems: { data, isLoading },
  } = useInvoiceFormContext();

  const [modalSelectCfopOpen, modalSelectCfopActions] = useDisclosure(false);
  const [modalSelectAliquotOpen, modalSelectAliquotActions] =
    useDisclosure(false);
  const [modalPartSelectOpen, modalPartSelectActions] = useDisclosure(false);
  const [modalTaskSelectOpen, modalTaskSelectActions] = useDisclosure(false);
  const [modalUpdateTaxesOpen, modalUpdateTaxesActions] = useDisclosure(false);

  const { mutateAsync: deleteMutateAsync } = useDeleteInvoiceNoteItems(
    Number(invoiceId),
  );
  const deleteMultipleInvoiceItems = useDeleteMultipleInvoiceItems();

  const invoiceType = useLocation().pathname.split('/datas')[0].slice(20, 23);

  const { invoice } = useInvoiceFormContext();

  const entity =
    invoice.data?.originReference && invoice.data?.originReference[0]?.entity;

  const [stockSelected, setStockSelected] = useState<StockItem>();
  const [itemPartIdSelected, setItemPartIdSelected] = useState<number>();
  const [taskSelected, setTaskSelected] = useState<Task>();
  const [itemTaskIdSelected, setItemTaskIdSelected] = useState<number>();

  const [selectedPartIds, setSelectedPartIds] = useState<Key[]>();

  // const handleSelectPart = (item: StockItem) => {
  //   if (item.partId) {
  //     history.push(`noteItens/createItemInvoice/part/${item.partId}`);
  //   } else if (item.consumableId) {
  //     history.push(
  //       `noteItens/createItemPurchase/consumable/${item.consumableId}`,
  //     );
  //   } else {
  //     history.push(`noteItens/createItemPurchase/task`);
  //   }

  //   return item;
  // };

  // const handleSelectService = () => {
  //   history.push(`noteItens/createServiceInvoice/service`);
  // };

  const handleRemove = async (id: number) => {
    Modal.confirm({
      title: intl({
        id: 'invoice.note.items.notifications.remove.confirm.title',
      }),
      content: `${intl({
        id: 'invoice.note.items.notifications.remove.confirm.content',
      })}`,
      onOk: async () => {
        try {
          await deleteMutateAsync(Number(id));
        } catch {}
      },
    });
  };

  const handleMultipleRemove = async () => {
    Modal.confirm({
      title: 'Você deseja realmente excluir esses itens?',
      content:
        'Ao remover os itens, todas as informações serão perdidas permanentemente. Ainda sim deseja continuar?',
      onOk: async () => {
        await deleteMultipleInvoiceItems.mutateAsync({
          invoiceId: Number(invoiceId),
          invoiceItemIds: selectedPartIds as number[],
        });
      },
    });
  };

  const columns: ColumnsType<InvoiceItemList> = [
    useConfigurationColumnsPart({ isSku: true, barcode: 'barCode' }),
    {
      title: title('description'),
      dataIndex: 'description',
      key: 'description',
      width: COLUMNS_WIDTH.default,
      ellipsis: true,
      render: (value: string) => value || '-',
    },
    {
      title: title('cfop'),
      dataIndex: 'cfopCode',
      key: 'cfopCode',
      width: COLUMNS_WIDTH.small,
      ellipsis: true,
      filterDropdown: () => null,
      filterIcon: (
        <FaExchangeAlt size={14} onClick={modalSelectCfopActions.open} />
      ),
      render: (value: string) => value || '-',
    },
    {
      title: title('ncm'),
      dataIndex: 'ncmCode',
      key: 'ncmCode',
      width: COLUMNS_WIDTH.small,
      ellipsis: true,
      render: (value: string) => value || '-',
    },
    {
      title: title('itemNumber'),
      dataIndex: 'itemNumber',
      key: 'itemNumber',
      width: COLUMNS_WIDTH.small,
      render: (value: string) => value || '-',
    },
    {
      title: title('qty'),
      dataIndex: 'quantity',
      key: 'quantity',
      width: COLUMNS_WIDTH.small,
      ellipsis: true,
      render: (value: number) => value || '-',
    },
    {
      title: title('unitPrice'),
      dataIndex: 'valueUnitary',
      key: 'valueUnitary',
      width: COLUMNS_WIDTH.small,
      ellipsis: true,
      render: (value: number) => formatterPrice(value || 0),
    },
    {
      title: title('discount'),
      dataIndex: 'valueDiscount',
      key: 'valueDiscount',
      width: COLUMNS_WIDTH.small,
      ellipsis: true,
      render: (value: number) => formatterPrice(value || 0),
    },
    {
      title: title('totalAmount'),
      dataIndex: 'total',
      key: 'total',
      width: COLUMNS_WIDTH.small,
      ellipsis: true,
      render: (value: number) => formatterPrice(value || 0),
    },
    {
      title: intl({
        id: 'commons.list.header.action',
      }),
      width: 100,
      fixed: 'right',
      align: 'right',
      render: (_, row) => (
        <Space>
          <EditIcon
            // redirect={`/app/fiscal/invoice/${invoiceType}/${invoiceId}/noteItens/editeItemInvoice/part/${row.id}`}
            iconProps={{ onClick: () => setItemPartIdSelected(row.id) }}
          />

          <Divider type="vertical" />

          <DeleteIcon
            disabled={
              !hasPermissions([Authorities.FISCAL_INVOICE_ITEM_DELETE]) ||
              disabledFields ||
              entity === InvoiceOriginReferenceEntity.PURCHASE
            }
            onClick={() => handleRemove(row.id)}
          />
        </Space>
      ),
    },
  ];

  const columnsNfs: ColumnsType<InvoiceItemList> = [
    {
      title: title('description'),
      dataIndex: 'description',
      key: 'description',
      width: COLUMNS_WIDTH.default,
      ellipsis: true,
      render: (value: string) => value || '-',
    },
    {
      title: title('qty'),
      dataIndex: 'quantity',
      key: 'quantity',
      width: COLUMNS_WIDTH.small,
      ellipsis: true,
      render: (value: number) => value || '-',
    },
    {
      title: title('unitPrice'),
      dataIndex: 'valueUnitary',
      key: 'valueUnitary',
      width: COLUMNS_WIDTH.small,
      ellipsis: true,
      render: (value: number) => formatterPrice(value || 0),
    },
    {
      title: title('discountUnconditioned'),
      dataIndex: 'unconditionalDiscount',
      key: 'unconditionalDiscount',
      width: COLUMNS_WIDTH.small,
      ellipsis: true,
      render: (value: number) => formatterPrice(value || 0),
    },
    {
      title: title('totalAmount'),
      dataIndex: 'total',
      key: 'total',
      width: COLUMNS_WIDTH.small,
      ellipsis: true,
      render: (value: number) => formatterPrice(value || 0),
    },
    {
      title: title('rate'),
      dataIndex: 'rate',
      key: 'rate',
      width: COLUMNS_WIDTH.small,
      ellipsis: true,
      filterDropdown: () => null,
      filterIcon: (
        <FaExchangeAlt size={14} onClick={modalSelectAliquotActions.open} />
      ),
      render: (value: string) =>
        typeof value === 'number'
          ? formatterPercent(value / 100, {
              minimumFractionDigits: 4,
              maximumFractionDigits: 4,
            })
          : '-',
    },
    {
      title: intl({
        id: 'commons.list.header.action',
      }),
      width: 100,
      fixed: 'right',
      align: 'right',
      render: (_, row) => (
        <Space>
          <EditIcon
            // redirect={`/app/fiscal/invoice/${invoiceType}/${invoiceId}/noteItens/editeItemInvoice/part/${row.id}`}
            iconProps={{ onClick: () => setItemTaskIdSelected(row.id) }}
          />

          <Divider type="vertical" />

          <DeleteIcon
            onClick={() => handleRemove(row.id)}
            disabled={disabledFields}
          />
        </Space>
      ),
    },
  ];

  return (
    <>
      <SpaceForButton justifyContent="end">
        {invoiceType !== InvoiceType.NFS && (
          <>
            <Button
              block
              type="primary"
              onClick={modalUpdateTaxesActions.open}
              disabled={!data?.length || disabledFields}
            >
              {intl({ id: 'invoiceNoteItems.button.updateTaxes' })}
            </Button>

            <Button
              block
              type="primary"
              onClick={modalPartSelectActions.open}
              disabled={disabledFields}
            >
              {intl({ id: 'invoiceNoteItems.button.selectPart' })}
            </Button>
          </>
        )}

        {invoiceType === InvoiceType.NFS && (
          <>
            <Button
              block
              type="primary"
              onClick={handleMultipleRemove}
              disabled={!selectedPartIds?.length || disabledFields}
            >
              {intl({ id: 'invoiceNoteItems.button.deleteSelectedServices' })}
            </Button>

            <Button
              block
              type="primary"
              onClick={modalTaskSelectActions.open}
              disabled={disabledFields}
            >
              {intl({ id: 'invoiceNoteItems.button.selectService' })}
            </Button>
          </>
        )}
      </SpaceForButton>

      <div style={{ margin: '24px 0px' }}>
        <InfiniteTable
          dataSource={data}
          columns={invoiceType === 'NFS' ? columnsNfs : columns}
          scroll={{ x: getTableScrollX(columns) }}
          loading={isLoading}
          rowKey={(row) => row.id}
          rowSelection={{
            preserveSelectedRowKeys: true,
            selectedRowKeys: selectedPartIds,
            onChange: setSelectedPartIds,
            getCheckboxProps: () => ({ disabled: disabledFields }),
          }}
        />
      </div>

      <ItemsStockModal
        invoiceNoteItems={data}
        itemType={StockItemType.Part}
        handleVisible={modalPartSelectActions.toggle}
        onSelectItem={setStockSelected}
        visible={modalPartSelectOpen}
      />

      {/* Part registration mode  */}
      <InvoicePartModal
        open={!!stockSelected}
        onCancel={() => setStockSelected(undefined)}
        invoice={!!stockSelected ? invoice.data : undefined}
        part={stockSelected}
      />

      {/* Part update mode */}
      <InvoicePartModal
        open={!!itemPartIdSelected}
        onCancel={() => setItemPartIdSelected(undefined)}
        invoice={!!itemPartIdSelected ? invoice.data : undefined}
        invoiceItemId={itemPartIdSelected}
      />

      {/* Update Taxes */}
      <UpdateTaxesModal
        selectedPartIds={selectedPartIds}
        open={modalUpdateTaxesOpen}
        onCancel={modalUpdateTaxesActions.close}
      />

      <SelectTasksListModal
        open={modalTaskSelectOpen}
        onCancel={() => {
          setTaskSelected(undefined);
          modalTaskSelectActions.close();
        }}
        onCallback={([task]) => setTaskSelected(task)}
        itemSelectedIds={data?.map((item) => item.taskId) || []}
        multiple={false}
        closeOnSelect={false}
      />

      {/* Service create modal */}
      <InvoiceItemServiceModal
        open={!!taskSelected}
        onCancel={() => setTaskSelected(undefined)}
        invoice={!!taskSelected ? invoice.data : undefined}
        task={taskSelected}
      />

      {/* Service update modal */}
      <InvoiceItemServiceModal
        open={!!itemTaskIdSelected}
        onCancel={() => setItemTaskIdSelected(undefined)}
        invoice={!!itemTaskIdSelected ? invoice.data : undefined}
        invoiceItemId={itemTaskIdSelected}
      />

      <NoteItemsSelectCfopModal
        onCancel={modalSelectCfopActions.toggle}
        open={modalSelectCfopOpen}
      />

      <NoteItemsSelectAliquotModal
        onCancel={modalSelectAliquotActions.toggle}
        open={modalSelectAliquotOpen}
      />
    </>
  );
}
